async function wait(ms: number): Promise<void> {
  return new Promise(
    resolve => setTimeout(resolve, ms),
  );
}

export default wait;
